// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { ProductPartnerAdvantagesImplModule } from "../product_partner_advantages_impl_module/ProductPartnerAdvantagesImplModule";

@Observer
@Component({
  mixins: [template],
  components: {
    ProductPartnerAdvantagesImplModule,
  },
})
export class ProductPartnerAdvantagesEditModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object): string {
    return "black";
  }

  get moduleInstances() {
    let result: object[] = [];

    this.instance["partnerstatus"].forEach((partnerStatus) => {
      this.instance["baureihen"].forEach((baureihe) => {
        result.push({
          advantage1: {
            color: partnerStatus["type"] === "vansolution" ? "white" : "black",
            headline: partnerStatus["headline"],
            subline: partnerStatus["subline"],
            content: partnerStatus["content"],
          },
          advantage2: {
            headline: baureihe["headline"],
            subline: baureihe["subline"],
            content: baureihe["content"],
          },
          common_options: this.instance["common_options"],
        });
      });
    });

    return result;
  }
}
